@let _selectedCommunity = selectedCommunity();
@if (workspaceList()) {
    @if (showDashboardLink()) {
        <div class="px-12 pt-2">
            @if (showMyCommunities()) {
                @let label = 'SIDEBAR.MY_COMMUNITIES' | translate;
                <ul class="flex flex-col" role="list">
                    <li>
                        <a
                            #rla="routerLinkActive"
                            class="ml-8 flex h-40 items-center text-text-mid-contrast hover:text-text"
                            [attr.aria-label]="expanded() ? undefined : label"
                            [routerLink]="'/dashboard'"
                            [routerLinkActive]="'text-text-primary hover:text-text-primary'"
                        >
                            <interacta-icon
                                class="mr-8 size-24"
                                [icon]="
                                    'people-heart' | filledIcon: rla.isActive
                                "
                                [matTooltip]="label"
                                [matTooltipDisabled]="expanded()"
                                [matTooltipPosition]="'right'"
                            />
                            <span
                                class="text-left typo-xs-bold transition-opacity duration-500"
                                [ngClass]="{
                                    'opacity-0': !expanded(),
                                    'opacity-100': expanded(),
                                }"
                                >{{ label }}</span
                            >
                        </a>
                    </li>
                </ul>
                @if (workspaceList().length) {
                    <interacta-separator
                        [ngClass]="{ 'block w-40': !expanded() }"
                        [thickness]="'soft'"
                    />
                }
            }
        </div>
    }
    @if (pinEnabled() && pinnedCommunities().length) {
        <div
            animate.enter="animate-collapse-in"
            animate.leave="animate-collapse-out"
            class="grid motion-reduce:animate-none"
        >
            <section
                class="flex flex-col overflow-hidden px-12 pt-8"
                data-testid="sidebar-pinned-communities"
            >
                @let pinnedLabel = 'SIDEBAR.PINNED_COMMUNITIES' | translate;
                <div
                    class="mb-4 flex items-center text-left text-text-mid-contrast"
                    [attr.aria-label]="expanded() ? undefined : pinnedLabel"
                >
                    <interacta-icon
                        class="size-24 transition-all duration-500"
                        [icon]="'pin-filled'"
                        [matTooltip]="pinnedLabel"
                        [matTooltipDisabled]="expanded()"
                        [matTooltipPosition]="'right'"
                        [ngClass]="{
                            'opacity-0': expanded(),
                            'ml-8 opacity-100': !expanded(),
                        }"
                    />
                    <span
                        class="line-clamp-2 grow typo-xs-bold wrap-break-word transition-all duration-500"
                        [ngClass]="{
                            'opacity-0': !expanded(),
                            '-ms-24 px-12 opacity-100': expanded(),
                        }"
                        >{{ pinnedLabel | uppercase }}
                    </span>
                </div>

                <ul class="flex flex-col" role="list">
                    @for (
                        community of pinnedCommunities();
                        track community.id
                    ) {
                        @if (
                            redirectTo() === 'community' &&
                            community.visibleInOrganizationTree
                        ) {
                            <li
                                animate.enter="animate-collapse-in"
                                animate.leave="animate-collapse-out"
                                class="grid motion-reduce:animate-none"
                                [ngClass]="{ 'mb-4': $last }"
                            >
                                <div class="overflow-hidden">
                                    <interacta-sidebar-community
                                        [community]="community"
                                        [expanded]="expanded()"
                                        [pinVisible]="pinEnabled()"
                                        [pinned]="
                                            {
                                                community,
                                                pinnedCommunities:
                                                    pinnedCommunities(),
                                            } | apply: isPinned
                                        "
                                        [selected]="
                                            _selectedCommunity !== null &&
                                            community.id ===
                                                _selectedCommunity.id
                                        "
                                        (communityPinned)="
                                            pinCommunity(community.id, $event)
                                        "
                                    />
                                </div>
                            </li>
                        }
                    }
                </ul>
                <interacta-separator
                    [ngClass]="{
                        'block w-40': !expanded(),
                    }"
                    [thickness]="'soft'"
                />
            </section>
        </div>
    }
    <ul data-testid="sidebar-workspace-tree">
        @for (workspace of workspaceList(); track workspace.id) {
            @if (uiStates()?.[workspace.id]; as uiState) {
                <li class="px-12">
                    <div class="py-4">
                        <button
                            class="w-full text-left"
                            type="button"
                            [attr.aria-expanded]="uiState.isAccordionOpen"
                            (click)="collapsedWs.emit(workspace.id)"
                        >
                            <interacta-sidebar-workspace
                                [expanded]="expanded()"
                                [isCollapsed]="uiState.isAccordionOpen"
                                [selected]="
                                    _selectedCommunity !== null &&
                                    workspace.id ===
                                        _selectedCommunity.workspaceId
                                "
                                [workspace]="workspace"
                            />
                        </button>

                        @if (uiState.isAccordionOpen) {
                            <ul>
                                @for (
                                    community of workspace.communities;
                                    track community.id
                                ) {
                                    @if (
                                        (redirectTo() === 'community' &&
                                            community.visibleInOrganizationTree) ||
                                        (redirectTo() === 'create' &&
                                            community.capabilities
                                                ?.createPost &&
                                            community.visibleInOrganizationTree)
                                    ) {
                                        <li>
                                            <interacta-sidebar-community
                                                [community]="community"
                                                [expanded]="expanded()"
                                                [pinVisible]="pinEnabled()"
                                                [pinned]="
                                                    {
                                                        community,
                                                        pinnedCommunities:
                                                            pinnedCommunities(),
                                                    } | apply: isPinned
                                                "
                                                [selected]="
                                                    _selectedCommunity !==
                                                        null &&
                                                    community.id ===
                                                        _selectedCommunity.id &&
                                                    workspace.id ===
                                                        _selectedCommunity.workspaceId
                                                "
                                                (communityPinned)="
                                                    pinCommunity(
                                                        community.id,
                                                        $event
                                                    )
                                                "
                                            />
                                        </li>
                                    }
                                }
                            </ul>
                        }
                    </div>
                    @if (!$last) {
                        <interacta-separator
                            [ngClass]="{ 'block w-40': !expanded() }"
                            [thickness]="'soft'"
                        />
                    }
                </li>
            }
        }
    </ul>
}
